import React from "react";
import { STRING_CONSTANT } from "../../constants/constants";
import { Field } from "formik";
import { t } from "i18next";

const FormInputField = (props) => {
  const { label, error, touched, fieldName, type, isVisible, isRequired, autoComplete, handleOnPaste, isEmailDuplicate, onBlur} =
    props;

  return (
    <div className={`mb-3 ${!isVisible && "d-none"}`} >
      <label
        htmlFor={fieldName}
        className={"form-label"}
      >
        {label}
        {isRequired && (
          <span className="text-danger">{STRING_CONSTANT.SPACE}*</span>
        )}
      </label>
      <Field
        type={type}
        className={"form-control"}
        id={fieldName}
        name={fieldName}
        autoComplete={autoComplete}
        onPaste={handleOnPaste}
        onBlur={onBlur}
      />
      {error && touched ? (
        <div className="text-danger">{error}</div>
      ) : (
        STRING_CONSTANT.BLANK
      )}
      {isEmailDuplicate ? (
        <div className="text-danger">{t("email-duplicate-error")}</div>
      ) : (
        STRING_CONSTANT.BLANK
      )}
    </div>
  );
};

export default FormInputField;
